import React from 'react';
import PropTypes from 'prop-types';

import { Stack, IconButton, Typography, Edit03Icon, Trash02Icon } from '@metarouter-private/mr-mui';

export default function SampleEventRow({ sampleEvent, onEdit, onDelete }) {
  const { name, description } = sampleEvent;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
    >
      <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body1" fontWeight="medium" noWrap>
          {name}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {description}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" spacing={1}>
        <IconButton size="small" onClick={() => onEdit(sampleEvent)} data-test-id="edit-sample-event-button">
          <Edit03Icon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={() => onDelete(sampleEvent)} data-test-id="delete-sample-event-button">
          <Trash02Icon fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
}

SampleEventRow.propTypes = {
  sampleEvent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
